export default __webpack_public_path__ + "static/media/icons.f3beaf73.png";